(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/tipsinfo/javascripts/tipsinfo-modal-content.js') >= 0) return;  svs.modules.push('/components/sport/tipsinfo/javascripts/tipsinfo-modal-content.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
(function (svs, React) {
  class TipsinfoModalContent extends React.Component {
    constructor(props) {
      super(props);
      _defineProperty(this, "state", {
        showOdds: this.props.showOdds,
        showSvF: this.props.showSvF,
        showLeagueAndSport: this.props.showLeagueAndSport,
        showMutuals: this.props.showMutuals,
        showTable: this.props.showTable,
        showLatest: this.props.showLatest
      });
      this.log = new svs.core.log.Logger('svs.sport.tipsinfo.TipsinfoModalContent');
      this.isAnyCheckedBound = this.isAnyChecked.bind(this);
      this.handleToggleAllTipsinfo = this.handleToggleAllTipsinfo.bind(this);
      this.handleToggleTipsinfo = this.handleToggleTipsinfo.bind(this);
    }
    isAnyChecked() {
      const state = this.state;
      return state.showOdds || state.showSvF || state.showLeagueAndSport || state.showMutuals || state.showTable || state.showLatest;
    }
    handleToggleAllTipsinfo() {
      this.setState(() => {
        const anyChecked = this.isAnyCheckedBound();
        const newValues = {
          showOdds: !anyChecked,
          showSvF: !anyChecked,
          showLeagueAndSport: !anyChecked,
          showMutuals: false,
          showTable: false,
          showLatest: false
        };
        return _objectSpread({}, newValues);
      }, () => {
        const state = this.state;
        const props = this.props;
        props.setTipsinfo({
          showOdds: state.showOdds,
          showSvF: state.showSvF,
          showLeagueAndSport: state.showLeagueAndSport,
          showMutuals: state.showMutuals,
          showTable: state.showTable,
          showLatest: state.showLatest
        });
      });
    }
    handleToggleTipsinfo(event) {
      const target = event.target;
      const value = target.checked;
      const name = target.name;
      const {
        setTipsinfo
      } = this.props;
      this.setState({
        [name]: value
      });
      setTipsinfo({
        [name]: value
      });
    }
    render() {
      const state = this.state;
      const hideShowText = this.isAnyCheckedBound() ? 'Göm' : 'Visa';
      return React.createElement("div", {
        className: "centered modal-bottom-padding"
      }, React.createElement("div", {
        className: "f-500 f-bold padding-xs-1 padding-xs-bottom-0"
      }, "V\xE4lj \xF6nskad Tipsinfo som ska visas i din kupong."), React.createElement("div", {
        className: "tipsinfo-links",
        id: "links"
      }, React.createElement("button", {
        className: "btn btn-transparent-default btn-block tipsinfo-clear-all js-btn-hideall",
        id: "clearall-button",
        onClick: this.handleToggleAllTipsinfo,
        type: "button"
      }, hideShowText, ' ', "all Tipsinfo"), React.createElement("ul", {
        className: "list-group list-group-default"
      }, React.createElement("li", {
        className: "list-group-item"
      }, React.createElement("div", {
        className: "form-toggle"
      }, React.createElement("input", {
        checked: state.showOdds,
        className: "form-toggle-input form-toggle-checkbox form-toggle-default js-tipsinfo ",
        id: "oddset-button",
        name: "showOdds",
        onChange: this.handleToggleTipsinfo,
        type: "checkbox",
        value: "Odds"
      }), React.createElement("label", {
        className: "form-label padding-xs-1 form-label-align-right",
        htmlFor: "oddset-button"
      }, React.createElement("div", {
        className: "form-label-btn"
      }), React.createElement("div", {
        className: "form-label-text"
      }, "Odds")))), React.createElement("li", {
        className: "list-group-item"
      }, React.createElement("div", {
        className: "form-toggle"
      }, React.createElement("input", {
        checked: state.showSvF,
        className: "form-toggle-input form-toggle-checkbox form-toggle-default js-tipsinfo ",
        id: "svf-button",
        name: "showSvF",
        onChange: this.handleToggleTipsinfo,
        type: "checkbox",
        value: "Svenska folket"
      }), React.createElement("label", {
        className: "form-label padding-xs-1 form-label-align-right",
        htmlFor: "svf-button"
      }, React.createElement("div", {
        className: "form-label-btn"
      }), React.createElement("div", {
        className: "form-label-text"
      }, "Svenska folket")))), React.createElement("li", {
        className: "list-group-item"
      }, React.createElement("div", {
        className: "form-toggle"
      }, React.createElement("input", {
        checked: state.showLeagueAndSport,
        className: "form-toggle-input form-toggle-checkbox form-toggle-default js-tipsinfo ",
        id: "sol-button",
        name: "showLeagueAndSport",
        onChange: this.handleToggleTipsinfo,
        type: "checkbox",
        value: "Sport och liga"
      }), React.createElement("label", {
        className: "form-label padding-xs-1 form-label-align-right",
        htmlFor: "sol-button"
      }, React.createElement("div", {
        className: "form-label-btn"
      }), React.createElement("div", {
        className: "form-label-text"
      }, "Sport och liga")))))));
    }
  }
  TipsinfoModalContent.defaultProps = {
    showLatest: false,
    showLeagueAndSport: false,
    showMutuals: false,
    showOdds: true,
    showSvF: true,
    showTable: false
  };
  svs.sport.tipsinfo.TipsinfoModalContent = TipsinfoModalContent;
})(svs, React);

 })(window);